import back5 from "../../../../imgs/back5.png";
import { useNavigate } from "react-router-dom";
import Nav from "../../vendor/navbar";
import Main from "./newProduct";
import { useDispatch, useSelector } from "react-redux";
const Listing = () => {
  const dispatch = useDispatch();
  const router = useNavigate();
  const user = useSelector((state) => state.user);
  const category = useSelector((state) => state.category);
  const SelectedOrderFlow = useSelector((state) => state.SelectedOrderFlow);

  return (
    <>
      <div className="bg-[#D9EFED] min-h-screen">
        <Nav />
        <div className="flex items-center justify-center  ">
          <div className="sm:w-[95%] w-full mt-[1rem] sm:px-10 px-6 rounded-md mb-12">
            <div className="cursor-pointer flex w-full items-center justify-center">
              <img
                onClick={() => {
                  if (user === "vendor-owner") {
                    router("/VendorDashboard");
                    return;
                  }
                  if (SelectedOrderFlow?.title === "Search Product") {
                    router("/Inventory/SelectProduct");
                    // router("/Inventory-Cart");
                    return;
                  }

                  if (user === "superadmin" || user === "admin" || user === "employee")
                    router("/SuperAdmin/Inventory/SelectVendor");
                  // else if (user === "admin") router("/Inventory-Categories");
                  // else if (user === "employee") router("/Inventory-Categories");
                  else router("/Inventory-Categories");
                }}
                className="sm:w-[1.7rem] w-[1.3rem]"
                src={back5}
                alt=""
              />
              <h2 className="font-bold w-full sm:text-[1.8rem] sm:ml-2 ml-[1rem] text-[1.4rem]">
                {user === "superadmin" || user === "employee"
                  ? "Products"
                  : category?.name
                  ? category?.name
                  : "Products"}
              </h2>
            </div>

            {/* <div className="bg-[#F6F4F4] mt-6 rounded-md p-8 mx-10"> */}
            <Main />
            {/* </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Listing;
